import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.PricingMultiplicationTypes')
export class PricingMultiplicationTypes extends AbstractModel {
  @JsonProperty([String], 'applyToField')
  applyToField?: string[]

  @JsonProperty([String], 'operation')
  operation?: string[]
}

